import { Component } from "react"
import PropTypes from "prop-types"
import { Tabs, Tab, Paper, Button, Badge } from "@mui/material"
import { SaveAlt } from "@mui/icons-material"
import SideSheet from "components/material/side-sheet"
import Loading from "components/material/loading"
import { csvLocation } from "helpers/csv"
import Trades from "./components/trades"
import { TRADE } from "./shapes"
import ExcelDownload from "components/excel-download"
import "./styles.scss"

export default class OptimizationTrades extends Component {
  static propTypes = {
    status: PropTypes.string,
    allPositions: PropTypes.arrayOf(TRADE),
    trades: PropTypes.arrayOf(TRADE),
    tradeType: PropTypes.string.isRequired,
    open: PropTypes.bool.isRequired,
    csvRows: PropTypes.arrayOf(
      PropTypes.arrayOf(
        PropTypes.oneOfType([
          PropTypes.string,
          PropTypes.number,
          PropTypes.object,
        ])),
    ).isRequired,
    fileName: PropTypes.string.isRequired,
    openTradeId: PropTypes.string,
    constraints: PropTypes.object.isRequired,
    applyButtonEnabled: PropTypes.bool.isRequired,
    setTradeConstraint: PropTypes.func.isRequired,
    setOpenTradeId: PropTypes.func.isRequired,
    toggleSaveExperiment: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    setTradeType: PropTypes.func.isRequired,
    openSecurityProfile: PropTypes.func.isRequired,
    openFactorProfile: PropTypes.func.isRequired,
    applyConstraints: PropTypes.func.isRequired,
    rebalanceTrades: PropTypes.array.isRequired,
    loadRebalance: PropTypes.func.isRequired,
    badges: PropTypes.object.isRequired,
    saveVisible: PropTypes.bool.isRequired,
    simulateVisible: PropTypes.bool.isRequired,
  }

  onTabChanged = (_, value) => {
    const { setTradeType } = this.props
    setTradeType(value)
  }

  onLoadRebalance = () => {
    const { rebalanceTrades, loadRebalance } = this.props
    loadRebalance(rebalanceTrades)
  }

  onApply = () => {
    const { applyConstraints, constraints } = this.props

    applyConstraints("securities", constraints)
  }

  renderTab = (type, label) => {
    const { badges } = this.props
    const badge = badges[type]
    if (badge) {
      const color = badge === "error" ? "error" : "secondary"
      const content = badge === "error" ? "!" : badge
      label = <Badge color={color} classes={{ badge: "badge" }} badgeContent={content}>
        {label}
      </Badge>
    }

    return <Tab value={type} label={label} />
  }

  render() {
    const {
      toggleSaveExperiment,
      status,
      trades,
      tradeType,
      open,
      onClose,
      openTradeId,
      constraints,
      applyButtonEnabled,
      setTradeConstraint,
      setOpenTradeId,
      openSecurityProfile,
      allPositions,
      saveVisible,
      simulateVisible,
      openFactorProfile,
      csvRows,
      fileName,
    } = this.props

    return <SideSheet open={open} title="Trades" onClose={onClose}>
      <div className="modules_optimization-trades">
        <ExcelDownload icon={<SaveAlt />} data={csvRows} fileName={fileName} type="Trades" location={csvLocation.optimization} className="download" />
        <Paper elevation={0}>
          <Tabs
            value={tradeType}
            onChange={this.onTabChanged}
            className="trade-type"
            indicatorColor="primary"
            textColor="primary"
          >
            {this.renderTab("buy", "Buy")}
            {this.renderTab("sell", "Sell")}
            {this.renderTab("short", "Short")}
            {this.renderTab("cover", "Buy to Cover")}
            {this.renderTab("all", "All Positions")}
          </Tabs>
        </Paper>
        {status === "loading" && <Loading />}
        {status === "ok" && <Trades
          trades={trades}
          allPositions={allPositions}
          openTradeId={openTradeId}
          constraints={constraints}
          setTradeConstraint={setTradeConstraint}
          setOpenTradeId={setOpenTradeId}
          openSecurityProfile={openSecurityProfile}
          openFactorProfile={openFactorProfile}
        />}
        {status === "ok" && <div className="buttons-bar">
          <Button variant="contained" color="primary" onClick={this.onApply} disabled={!applyButtonEnabled}>Apply</Button>
          <div className="simulate-trades-button">
            {saveVisible && <Button onClick={toggleSaveExperiment} className="save-compare" variant="contained" color="primary">Save Experiment</Button>}
            {simulateVisible && <Button variant="contained" color="secondary" onClick={this.onLoadRebalance}>Simulate</Button>}
          </div>
        </div>}
      </div>
    </SideSheet>
  }
}
